import { createApiCall } from 'services';

import { call, fork, put, takeLatest } from 'redux-saga/effects';

import { Action, IDataList } from '../model';
import {
    fetchInstallationsSuccess,
    fetchInstallationsFailure
} from './actions';
import {
    INSTALLATIONS_ACTION_TYPES,
    FetchInstallationsParams,
    Installation
} from './types';






export function* installationsSaga(): Generator {
    yield takeLatest(
        INSTALLATIONS_ACTION_TYPES.FETCH_INSTALLATIONS_REQUEST,
        fetchInstallationsSaga
    )
}

function* fetchInstallationsSaga(
    action: Action<FetchInstallationsParams>
): Generator<any, void, IDataList<Installation[]>> {
    try {
        console.log(action.payload, 'action.payload');
        const response = yield call(
            createApiCall,
            {
                method: 'GET',
                url: '/installations/admin',
                params: action.payload
            }
        );
        console.log(response);
        yield put(fetchInstallationsSuccess(response));
    } catch (error: unknown) {
        const errorMessage = error instanceof Error ? error.message : 'An unknown error occurred';
        yield put(fetchInstallationsFailure(errorMessage));
    }
}

export default [
    fork(installationsSaga)
]